/**
 * Certified Block - Slick Slider with Counter Animation
 */

(function () {
  "use strict";

  // Counter animation function
  function animateCounter(numberElement) {
    if (!numberElement) {
      console.log("[COUNTER] No number element");
      return;
    }

    if (!window.gsap) {
      console.log("[COUNTER] GSAP not available");
      return;
    }

    // Get the target number from data attribute
    const targetNumber = parseFloat(numberElement.getAttribute("data-target"));

    console.log("[COUNTER] Animating to:", targetNumber);

    if (isNaN(targetNumber)) {
      console.log("[COUNTER] Invalid target number");
      return;
    }

    // Create an object to animate
    const counter = { value: 0 };

    // Animate from 0 to target number
    return window.gsap.to(counter, {
      value: targetNumber,
      duration: 2,
      ease: "power2.out",
      onUpdate: function () {
        // Update the text with the current value
        // If it's a whole number, show no decimals, otherwise show up to 1 decimal
        const displayValue =
          targetNumber % 1 === 0
            ? Math.round(counter.value)
            : counter.value.toFixed(1);
        numberElement.textContent = displayValue;
      },
      onComplete: function () {
        console.log("[COUNTER] Animation complete:", targetNumber);
      },
    });
  }

  // Animate slide content with fade up
  function animateSlideContent(slide) {
    if (!slide || !window.gsap) return;

    const numberWrapper = slide.querySelector(".number_wrapper");
    const contentArticle = slide.querySelector(".content");
    const title = contentArticle
      ? contentArticle.querySelector(".title")
      : null;
    const lineWrap = contentArticle
      ? contentArticle.querySelector(".line_wrap")
      : null;
    const description = contentArticle
      ? contentArticle.querySelector(".description")
      : null;
    const buttons = contentArticle
      ? contentArticle.querySelector(".buttons_wrapper")
      : null;
    const numberElement = slide.querySelector(".number");

    // Create timeline for sequenced animations
    const tl = window.gsap.timeline();

    // Set initial states (hidden and down)
    window.gsap.set([numberWrapper, title, lineWrap, description, buttons], {
      opacity: 0,
      y: -30,
    });

    // Animate left side (number_wrapper) first
    tl.to(numberWrapper, {
      opacity: 1,
      y: 0,
      duration: 0.6,
      ease: "power2.out",
    });

    // Then animate right side elements with stagger
    const rightElements = [title, lineWrap, description, buttons].filter(
      Boolean
    );
    if (rightElements.length > 0) {
      tl.to(
        rightElements,
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.15,
          ease: "power2.out",
        },
        "-=0.3" // Slight overlap with previous animation
      );
    }

    // Finally animate the counter
    if (numberElement) {
      tl.add(() => animateCounter(numberElement), "-=0.5");
    }

    return tl;
  }

  function initCertifiedSlider() {
    const blocks = document.querySelectorAll(".certified");

    blocks.forEach((block) => {
      const slider = block.querySelector(".certified_slider");
      if (!slider) return;

      // Check if jQuery and Slick are available
      if (
        typeof window.$ === "undefined" ||
        typeof window.$.fn.slick === "undefined"
      ) {
        console.warn("[BLOCK] jQuery or Slick not available yet, retrying...");
        setTimeout(() => initCertifiedSlider(), 100);
        return;
      }

      // Check if already initialized
      if (window.$(slider).hasClass("slick-initialized")) {
        console.log("[BLOCK] Certified slider already initialized, skipping");
        return;
      }

      // Get all slides and their numbers
      const slides = slider.querySelectorAll(".certified__slide");

      // Store original numbers as data attributes
      slides.forEach((slide) => {
        const numberElement = slide.querySelector(".number");
        if (numberElement) {
          const originalNumber = numberElement.textContent;
          numberElement.setAttribute("data-target", originalNumber);
          numberElement.textContent = "0"; // Start at 0
        }
      });

      // Initialize Slick Slider
      window.$(slider).slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: "ease-out",
        autoplay: false,
      });

      // Animate first slide when block comes into view
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            console.log("[COUNTER] Block intersecting:", entry.isIntersecting);
            if (entry.isIntersecting) {
              // Animate the first slide's content and counter
              const firstSlide = slides[0];
              setTimeout(() => animateSlideContent(firstSlide), 300);
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.3 }
      );

      observer.observe(block);
      console.log("[COUNTER] Observer attached to block");

      // Animate content on slide change
      window.$(slider).on("afterChange", function (event, slick, currentSlide) {
        console.log("[COUNTER] Slide changed to:", currentSlide);
        const activeSlide = slides[currentSlide];

        if (activeSlide) {
          // Reset number to 0 first
          const numberElement = activeSlide.querySelector(".number");
          if (numberElement) {
            numberElement.textContent = "0";
          }
          // Animate all content with fade up
          setTimeout(() => animateSlideContent(activeSlide), 100);
        }
      });

      console.log(
        "[BLOCK] certified slider initialized with counter animation"
      );
    });
  }

  // Initialize with retries
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(initCertifiedSlider, 100);
      setTimeout(initCertifiedSlider, 300);
    });
  } else {
    setTimeout(initCertifiedSlider, 100);
    setTimeout(initCertifiedSlider, 300);
  }
})();
